import styled from "styled-components";

export const StyledPromotions = styled.div`
    .state {
        text-align: center;
        padding: 2rem;
        color: var(--color-text-secondary);
    }

    .state.error {
        color: var(--color-danger);
    }

    .product-image {
        width: 100%;
        height: 200px;
        overflow: hidden;
        position: relative;
    }

    .product-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.2s ease;
        display: block;
    }

    .product-card:hover .product-image img {
        transform: scale(1.05);
    }

    .product-content {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .product-sku {
        font-size: 0.85rem;
        color: var(--color-text-secondary);
        margin-bottom: 0.25rem;
        display: block;
    }

    .product-content h3 {
        margin: 0;
        padding: 0;
        color: var(--color-primary);
        font-size: 1.4rem;
        font-weight: 700;
    }

    .product-content img {
        cursor: pointer;
    }

    .product-content p {
        margin: 0 0 0.75rem 0;
        color: var(--color-text-secondary);
        font-size: 0.95rem;
    }

    @media (max-width: 768px) {
        .product-image {
            height: 180px;
        }
    }

    @media (max-width: 480px) {
        .product-content {
            padding: 0.75rem;
        }

        .product-content p {
            font-size: 0.85rem;
        }

        .product-content h3 {
            font-size: 1rem;
        }
    }

    .stories-grid {
        display: flex;
        flex-direction: column;
        @media (min-width: 992px) {
            flex-direction: row;
            flex-wrap: wrap;
        }
    }

    @media (min-width: 576px) {
        .stories-grid__item{
            width: 50%;
            padding-right: 10px;
        }
    }
    @media (min-width: 1200px) {
        .stories-grid__item{
            width: 25%;
            padding-bottom: inherit;
            min-width: auto;
        }
    }
    @media (min-width: 1367px) {
        .stories-grid__item{
            width: 20%;
            padding-bottom: inherit;
        }
    }

    .storyItem__image{
        height: auto;
        img{
            width: 100%;
            object-fit: cover;
            aspect-ratio: 1 / 1;
            transform: scale(1);
            transition: .2s ease-in;
            display: block;
            height: auto;
        }
    }
`;


